export class ErrorInformation {
    Message: string;
    ErrorType?: number;
}
